import inputTypes from "./inputType";
import { hasProp } from "../_util/props-util";
import "./style/index.scss";
import WIcon from "../wicon";

const props = inputTypes();

function fixControlledValue(value) {
  if (typeof value === "undefined" || value === null) {
    return "";
  }
  return value;
}

export default {
  inheritAttrs: false,
  name: "WInput",
  __WF_: true,
  model: {
    prop: "value",
    event: "change.value"
  },
  components: {
    WIcon
  },
  props,
  data() {
    const { value, defaultValue, type } = this.$props;
    return {
      stateValue: fixControlledValue(!hasProp(this, "value") ? defaultValue : value),
      stateType: type
    };
  },
  computed: {
    classes() {
      const { prefixCls } = this;
      return {
        [`${prefixCls}`]: true
      };
    },
    containerCls() {
      const { prefixCls, labelPosition } = this;
      return {
        [`${prefixCls}-container-${labelPosition}`]: true,
        [`${prefixCls}-container`]: true
      };
    },
    labelCls() {
      const { prefixCls } = this;
      return [`${prefixCls}-label`];
    },
    controlCls() {
      const { prefixCls, error, disabled } = this;
      return {
        [`${prefixCls}-control`]: true,
        [`${prefixCls}-disabled`]: disabled,
        [`${prefixCls}-error`]: error
      };
    },
    passwordIconType() {
      const { stateType } = this;
      return stateType === "password" ? "icon-yanjing" : "icon-in_biyan_fill";
    }
  },
  watch: {
    value(val) {
      this.stateValue = fixControlledValue(val);
    }
  },
  methods: {
    handleChange(e) {
      if (!hasProp(this, "value")) {
        this.stateValue = e.target.value;
      } else {
        this.$forceUpdate();
      }
      // if (e.target.composing) {
      this.$emit("change.value", e.target.value);
      // }
      this.$emit("change", e);
      this.$emit("input", e);
    },
    passwordShowHidden() {
      const { stateType } = this;
      console.log("???");
      this.stateType = stateType === "password" ? "text" : "password";
    }
  },
  render() {
    const {
      stateValue,
      classes,
      $listeners,
      $slots,
      $attrs,
      placeholder,
      disabled,
      maxLength,
      type,
      stateType,
      containerCls,
      labelCls,
      controlCls,
      handleChange,
      passwordIconType,
      passwordShowHidden
    } = this;
    const inputProps = {
      domProps: {
        value: stateValue
      },
      attrs: {
        ...$attrs,
        disabled,
        placeholder,
        maxLength,
        type: stateType
      },
      class: classes,
      on: {
        ...$listeners,
        input: handleChange
      },
      ref: "inputNode"
    };
    return (
      <div class={containerCls}>
        {$slots.label ? <div class={labelCls}>{$slots.label}</div> : null}
        <div class={controlCls}>
          <input {...inputProps} />
          {type == "password" ? (
            <w-icon type={passwordIconType} onclick={passwordShowHidden} />
          ) : null}
        </div>
      </div>
    );
  }
};
